export default __webpack_public_path__ + "static/media/news103.206580ae.jpg";